import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { CartaoBandeira } from 'src/app/model/financeiro/cartaoBandeira';

@Injectable({
  providedIn: 'root'
})
export class CartaoBandeiraService extends GenericService<CartaoBandeira>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("cartaobandeira")
  }
}
